const defaultMarkdown = `
# Welcome to my Markdown Previewer!

## This is a sub-heading

You can make text **bold** or *italic*.

You can also do \`inline code\`.

\`\`\`js
// code block
function hello() {
  console.log("Hello Markdown!");
}
\`\`\`

> Blockquote example

- List item 1
- List item 2

[NCG](https://github.com/nca-gabriel)

![Image](https://picsum.photos/200)
`;

module.exports = defaultMarkdown;
